import { Checkbox, Divider, Space, Form, Typography, Input, Button, Tooltip, Spin, Select } from "antd";
import React, { useState } from "react";
import BMInput from "../../admin/comps/BMInput";
import ColourPicker from "./ColourPicker";
import StylePicker from "./StylePicker";
import { BorderLeftOutlined, BorderTopOutlined, BorderRightOutlined, BorderBottomOutlined } from '@ant-design/icons';
import FontPicker from "./FontPicker";
import { getLightness, tt_border_enable, tt_border_radius, tt_border_size, tt_font_size, tt_letter_spacing, tt_line_height, tt_padding_x, tt_padding_y, tt_shadow_blur, tt_shadow_spread, tt_shadow_x, tt_shadow_y } from "../../utils/Utils";
import { FontSizeIcon, LetterSpacingIcon, LineHeightIcon, PaddingHorizontalIcon, PaddingVerticalIcon } from "../../admin/Icons";
import MobileSelector from "../../admin/UI/MobileSelector";

export default function StyleContent(props) {

    const { default_style = {}, data = [], saveNew = () => { }, save = () => { }, content = {}, is_new = false, is_edit = false, close = () => { }, callback = () => { }, contents = [], setView = () => { } } = props;
    const { fonts = [], text_styles = [], colours = [] } = data;
    const [form] = Form.useForm();
    const [textAlign,] = useState("center");
    const [mobile, setMobile] = useState(false)

    const {
        id = 1,
        name = "",
        font = 0,
        font_size = 14,
        font_style = 1,
        letter_spacing = 0,
        line_height = 120,
        colour = 0,
        padding_x = 0,
        padding_y = 0,
        text_shadow_colour = 0,
        text_shadow_x = 0,
        text_shadow_y = 0,
        text_shadow_blur = 0,
        underline_colour = 0,
        underlined = false,
        border_colour = 0,
        border_size = 0,
        border_radius = 0,
        border_left = 0,
        border_top = 0,
        border_right = 0,
        border_bottom = 0,
        background_colour = 0,
        background_visible = false,
        background_shadow_colour = 0,
        background_shadow_x = 0,
        background_shadow_y = 0,
        background_shadow_blur = 0,
        background_shadow_spread = 0,
        allow_mobile_overrides = false,
        mobile_font_size = 14,
        mobile_line_height = 120,
        mobile_padding_x = 0,
        mobile_padding_y = 0,
        text_transform  = "none"

    } = content;

    
    const StyleContentForm = (props) => {

        const { callback = () => { }, id = 0, is_new = true, close = () => { }, save = () => { }, name = "" } = props;
        // Save name + activate button (if not activated)
        const saveName = (_f) => {
            if (is_new) {
                saveNew(_f.name, { ...default_style })
            } else {
                save(id, _f.name, ["name"], is_new);
            }
            close();
            callback(id);
        }

        return (
            <>
                <div onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        form.submit();
                        e.stopPropagation();
                        e.preventDefault();
                    }
                }} key={id} style={{ "padding": "20px" }}>
                    <Typography.Title level={5}>{(is_new) ? "New" : "Edit"} Content Text</Typography.Title>
                    <Divider style={{ "margin": "15px 0px" }} dashed />
                    <Form form={form} onFinish={(_f) => saveName(_f)} layout="vertical">
                        <Form.Item name="id" initialValue={id} noStyle>
                            <Input hidden />
                        </Form.Item>
                        <Form.Item initialValue={(is_new) ? "" : name} rules={[{ required: true, message: "Content text name is required" }]} label="Name" name="name">
                            <Input maxLength={28} placeholder="Content text name..." />
                        </Form.Item>
                        <div className="float-flex">
                            <div>&nbsp;</div>
                            <Button htmlType="submit" type="primary">Save</Button>
                        </div>
                    </Form>
                </div>
            </>
        )
    }

    // NEW AND EDIT FORM
    if (is_new || is_edit) {
        return (
            <>
                <StyleContentForm callback={callback} save={save} close={close} id={id} name={name} is_new={is_new} />
            </>
        )
    }

    const drawPreview = () => {

        let _c = colours.find(item => item.id === colour) || {style : "rgba(0,0,0,1)"}
        let _lightness = getLightness(_c.style);
        
        let _bg = (_lightness > 0.7) ? "#aaa" : "#fafafa"

        let preview_text = (font_size > 20) ? "Lorem ipsum" : "Lorem ipsum dolor sit amet, consectetur adipiscing elit."
        return (
            <div className="label-border" style={{ "textAlign": "left" }}>
                <div style={{ "height": "100px", "overflow": "hidden", "display": "flex", "alignItems": "center", backgroundColor : _bg }}>
                    <div style={{ "textAlign": textAlign }}>
                        <span className={"bm-txt-" + id}>{preview_text}</span>
                    </div>
                </div>
            </div>
        )
    }



    const drawMobile = () => {

        return (
            <>

                <Checkbox onChange={(e) => save(id, e.target.checked, ["allow_mobile_overrides"])} checked={allow_mobile_overrides}><small>Enable Overides?</small></Checkbox>
                <div className="shim" /><div className="shim" />
                <Spin spinning={!allow_mobile_overrides} indicator={<></>}>
                    {/* SIZE / LINE HEIGHT / PADDING */}
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">SIZE / LINE HEIGHT / PADDING</Divider>
                    <div className="float-flex">
                        <Space>
                            <BMInput width={"45px"} value={mobile_font_size} onChange={(_v) => save(id, _v, ["mobile_font_size"])} number min={14} max={100} prefix={<Tooltip title={tt_font_size}><FontSizeIcon style={{ "color": "#888", "fontSize": "12px" }} /></Tooltip>} />
                            <BMInput width={"45px"} value={mobile_line_height} onChange={(_v) => save(id, _v, ["mobile_line_height"])} percent={true} number hide_increment min={0} max={300} prefix={<Tooltip title={tt_line_height}><LineHeightIcon style={{ "color": "#888", "fontSize": "12px" }} /></Tooltip>} />
                            <BMInput width={"45px"} value={mobile_padding_x} onChange={(_v) => save(id, _v, ["mobile_padding_x"])} number min={0} max={100} prefix={<Tooltip title={tt_padding_x}><PaddingHorizontalIcon style={{ "color": "#888" }} /></Tooltip>} />
                            <BMInput width={"45px"} value={mobile_padding_y} onChange={(_v) => save(id, _v, ["mobile_padding_y"])} number min={0} max={100} prefix={<Tooltip title={tt_padding_y}><PaddingVerticalIcon style={{ "color": "#888" }} /></Tooltip>} />
                        </Space>
                        <div />
                    </div>
                </Spin>
                <div className="shim" /><div className="shim" />
            </>
        )
    }


    const drawDesktop = () => {

        return (
            <>


                {/* FONT */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">FONT / SIZE</Divider>
                <div className="float-flex">
                    <FontPicker value={font} onChange={(_v) => save(id, _v, ["font"])} fonts={fonts} />
                    <BMInput value={font_size} onChange={(_v) => save(id, _v, ["font_size"])} number min={14} max={100} prefix={<Tooltip title={tt_font_size}><FontSizeIcon style={{ "color": "#888", "fontSize": "12px" }} /></Tooltip>} />
                </div>
                <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">STYLE / SPACING</Divider>
                <div className="float-flex">
                    <StylePicker value={font_style} onChange={(_v) => save(id, _v, ["font_style"])} styles={text_styles} />
                    <BMInput value={letter_spacing} onChange={(_v) => save(id, _v, ["letter_spacing"])} number min={-100} max={300} prefix={<Tooltip title={tt_letter_spacing}><LetterSpacingIcon style={{ "color": "#888", "fontSize": "12px" }} /></Tooltip>} />
                    <BMInput value={line_height} onChange={(_v) => save(id, _v, ["line_height"])} percent={true} number hide_increment min={0} max={300} prefix={<Tooltip title={tt_line_height}><LineHeightIcon style={{ "color": "#888", "fontSize": "12px" }} /></Tooltip>} />
                </div>
                <div className="shim" />
                {/* PADDING */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">TEXT TRANSFORM / PADDING</Divider>
                <div className="float-flex">
                <div>
                        <Select style={{"width" : "120px"}} value={text_transform} onChange={(_v) => save(id, _v, ["text_transform"])}>
                            <Select.Option value="none"><small>None</small></Select.Option>
                            <Select.Option value="uppercase"><small>Uppercase</small></Select.Option>
                            <Select.Option value="lowercase"><small>Lowercase</small></Select.Option>
                            <Select.Option value="capitalize"><small>Capitalize</small></Select.Option>
                        </Select>
                    </div>
                    <Space>
                        <BMInput value={padding_x} onChange={(_v) => save(id, _v, ["padding_x"])} number min={0} max={100} prefix={<Tooltip title={tt_padding_x}><PaddingHorizontalIcon style={{ "color": "#888" }} /></Tooltip>} />
                        <BMInput value={padding_y} onChange={(_v) => save(id, _v, ["padding_y"])} number min={0} max={100} prefix={<Tooltip title={tt_padding_y}><PaddingVerticalIcon style={{ "color": "#888" }} /></Tooltip>} />
                    </Space>
                    
                </div>
                <div className="shim" /><div className="shim" />
                {/* COLOR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">TEXT COLOUR</Divider>
                <ColourPicker allow_none value={colour} onChange={(_v) => save(id, _v, ["colour"])} />
                <div className="shim" /><div className="shim" />
                {/* UNDERLINE */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">UNDERLINE</Divider>
                <ColourPicker allow_none value={underline_colour} onChange={(_v) => save(id, _v, ["underline_colour"])} />
                <div className="shim" />
                <div className="float-flex">
                    <div></div>
                    <div><Checkbox checked={underlined} onChange={(_e) => save(id, _e.target.checked, ["underlined"])}><small>Underline</small></Checkbox></div>
                </div>
                <div className="shim" /><div className="shim" />
                {/* SHADOW */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">TEXT SHADOW</Divider>
                <ColourPicker allow_none value={text_shadow_colour} onChange={(_v) => save(id, _v, ["text_shadow_colour"])} colours={colours} />
                <div className="shim" />
                <div className="float-flex-right">
                    <BMInput value={text_shadow_x} onChange={(_v) => save(id, _v, ["text_shadow_x"])} number min={0} max={100} prefix={<Tooltip title={tt_shadow_x}>X</Tooltip>} />
                    <BMInput value={text_shadow_y} onChange={(_v) => save(id, _v, ["text_shadow_y"])} number min={0} max={100} prefix={<Tooltip title={tt_shadow_y}>Y</Tooltip>} />
                    <BMInput value={text_shadow_blur} onChange={(_v) => save(id, _v, ["text_shadow_blur"])} number min={0} max={100} prefix={<Tooltip title={tt_shadow_blur}>BLUR</Tooltip>} />
                </div>
                {/* BORDER */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BORDER</Divider>
                <ColourPicker allow_none value={border_colour} onChange={(_v) => save(id, _v, ["border_colour"])} />
                <div className="shim" />
                <div className="float-flex-right">
                    <BMInput value={border_radius} onChange={(_v) => save(id, _v, ["border_radius"])} number min={0} max={100} prefix={<Tooltip title={tt_border_radius}>RADIUS</Tooltip>} />
                    <BMInput value={border_size} onChange={(_v) => save(id, _v, ["border_size"])} number min={0} max={100} prefix={<Tooltip title={tt_border_size}>SIZE</Tooltip>} />
                    <Space>
                        <div><Tooltip title={<>{tt_border_enable}<small> left</small></>}><BorderLeftOutlined onClick={() => save(id, !border_left, ["border_left"])} style={{ "color": (border_left) ? "#1890ff" : "#AAA" }} /></Tooltip></div>
                        <div><Tooltip title={<>{tt_border_enable}<small> top</small></>}><BorderTopOutlined onClick={() => save(id, !border_top, ["border_top"])} style={{ "color": (border_top) ? "#1890ff" : "#AAA" }} /></Tooltip></div>
                        <div><Tooltip title={<>{tt_border_enable}<small> right</small></>}><BorderRightOutlined onClick={() => save(id, !border_right, ["border_right"])} style={{ "color": (border_right) ? "#1890ff" : "#AAA" }} /></Tooltip></div>
                        <div><Tooltip title={<>{tt_border_enable}<small> bottom</small></>}><BorderBottomOutlined onClick={() => save(id, !border_bottom, ["border_bottom"])} style={{ "color": (border_bottom) ? "#1890ff" : "#AAA" }} /></Tooltip></div>
                    </Space>
                </div>
                <div className="shim" /><div className="shim" />
                {/* COLOR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND COLOUR</Divider>
                <ColourPicker allow_gradient allow_none value={background_colour} onChange={(_v) => save(id, _v, ["background_colour"])} colours={colours} />
                <div className="shim" />
                <div className="float-flex">
                    <div></div>
                    <Checkbox checked={background_visible} onChange={(e) => save(id, e.target.checked, ["background_visible"])} ><small>Visible</small></Checkbox>
                </div>
                <div className="shim" /><div className="shim" />
                {/* BG SHADOW */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND SHADOW</Divider>
                <ColourPicker allow_none value={background_shadow_colour} onChange={(_v) => save(id, _v, ["background_shadow_colour"])} colours={colours} />
                <div className="float-flex-right">
                    <BMInput width="43px" value={background_shadow_x} onChange={(_v) => save(id, _v, ["background_shadow_x"])} number min={0} max={100} prefix={<Tooltip title={tt_shadow_x}>X</Tooltip>} />
                    <BMInput width="43px" value={background_shadow_y} onChange={(_v) => save(id, _v, ["background_shadow_y"])} number min={0} max={100} prefix={<Tooltip title={tt_shadow_y}>Y</Tooltip>} />
                    <BMInput width="43px" value={background_shadow_blur} onChange={(_v) => save(id, _v, ["background_shadow_blur"])} number min={0} max={100} prefix={<Tooltip title={tt_shadow_blur}>BLUR</Tooltip>} />
                    <BMInput width="43px" value={background_shadow_spread} onChange={(_v => save(id, _v, ["background_shadow_spread"]))} number min={0} max={100} prefix={<Tooltip title={tt_shadow_spread}>SPREAD</Tooltip>} />
                </div>
            </>
        )

    }

    const draw = () => {
        if (mobile) {
            return drawMobile()
        } else {
            return drawDesktop();
        }
    }

    return (
        <>
            {drawPreview()}
            <div className="shim" /><div className="shim" />
            <div style={{ "padding": "5px" }}><MobileSelector setView={setView} onChange={(e) => setMobile(e)} /></div>
            <div className="shim" /><div className="shim" />
            {draw()}
        </>
    )
}